import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Menu01Icon from '@untitled-ui/icons-react/build/esm/Menu01';
import {
  Box,
  Chip,
  Container,
  IconButton,
  Stack,
  SvgIcon,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Logo } from 'src/components/logo';
import { brandConfig } from 'src/config/brand';
import { RouterLink } from 'src/components/router-link';
import { useWindowScroll } from 'src/hooks/use-window-scroll';
import { paths } from 'src/paths';
import { AccountButton } from '../dashboard/account-button';

const TOP_NAV_HEIGHT = 64;

export const TopNav = (props) => {
  const { onMobileNavOpen } = props;
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const [elevate, setElevate] = useState(false);

  const handleWindowScroll = useCallback(() => {
    setElevate(window.scrollY > 64);
  }, []);

  useWindowScroll({
    handler: handleWindowScroll,
    delay: 100,
  });

  return (
    <Box
      component="header"
      sx={{
        left: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        pt: 2,
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          backdropFilter: 'blur(6px)',
          backgroundColor: 'transparent',
          borderRadius: 2.5,
          boxShadow: 'none',
          transition: (theme) =>
            theme.transitions.create('box-shadow, background-color', {
              easing: theme.transitions.easing.easeInOut,
              duration: 200,
            }),
          ...(elevate && {
            backgroundColor: (theme) =>
              alpha(theme.palette.background.paper, 0.9),
            boxShadow: 8,
          }),
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ height: TOP_NAV_HEIGHT, px: 2 }}
        >
          {/* Logo */}
          <Stack
            alignItems="center"
            component={RouterLink}
            direction="row"
            display="inline-flex"
            href={paths.index}
            spacing={1}
            sx={{ textDecoration: 'none' }}
          >
            <Box sx={{ display: 'inline-flex', height: 34, width: 34 }}>
              <Logo />
            </Box>
            <Typography
              sx={{
                color: 'text.primary',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: 16,
                fontWeight: 800,
              }}
            >
              {brandConfig.name}
            </Typography>
            <Chip
              label="beta"
              size="small"
              color="info"
              sx={{
                height: 20,
                flexShrink: 0,
                fontSize: 11,
                fontWeight: 600,
                '& .MuiChip-label': { px: 0.75 },
              }}
            />
          </Stack>

          {/* Right side */}
          <Stack
            alignItems="center"
            direction="row"
            spacing={2}
          >
            <AccountButton />
            {!mdUp && (
              <IconButton onClick={onMobileNavOpen}>
                <SvgIcon fontSize="small">
                  <Menu01Icon />
                </SvgIcon>
              </IconButton>
            )}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

TopNav.propTypes = {
  onMobileNavOpen: PropTypes.func,
};
